import React, { memo, lazy } from "react";
import { Switch } from "react-router-dom";
import { useLocationBlocker } from "hooks";
import PropsRoute from "shared/components/PropsRoute";

const Home = lazy(() => import("./home/Home"));
const Login = lazy(() => import("./login/Login"));
const Notifies = lazy(() => import("./notifies/Notifies"));
const Purchased = lazy(() => import("./purchased/Purchased"));
const Order = lazy(() => import("./order/Order"));
const Invoice = lazy(() => import("./invoice/Invoice"));
const Setting = lazy(() => import("./setting/Setting"));
const CustomerCase = lazy(() => import("./customerCase"));
const AboutUs = lazy(() => import("./aboutUs"));
const ContactUs = lazy(() => import("./contactUs"));
const VSPage = lazy(() => import("./vsPage"));
const Payment = lazy(() => import("./payment/Payment"));
const DepReport = lazy(() => import("./product/bigdata/depReport"));
const DepReportResult = lazy(() => import("./product/bigdata/depReport/Result"));
const CstRcScore = lazy(() => import("./product/bigdata/cstRcScore"));
const CstRcScoreResult = lazy(() => import("./product/bigdata/cstRcScore/Result"));
const CstRcScoreDashboard = lazy(() => import("./product/bigdata/cstRcScore/Dashboard"));
const ProductLogistics = lazy(() => import("./product/logistics"));
const ProductService = lazy(() => import("./product/service"));



// 需：改写成懒加载形式加载路由
function Routing() {
  useLocationBlocker();

  return (
    <Switch>
      <PropsRoute exact path="/login" component={Login} />
      <PropsRoute exact path="/cases" component={CustomerCase} />
      <PropsRoute exact path="/about" component={AboutUs} />
      <PropsRoute exact path="/contact" component={ContactUs} />
      <PropsRoute exact path="/notifies" component={Notifies} />

      <PropsRoute exact path="/vsPage" component={VSPage} />
      <PropsRoute exact path="/payment" component={Payment} />

      <PropsRoute exact path="/product/logistics" component={ProductLogistics} />
      <PropsRoute exact path="/product/service" component={ProductService} />
      <PropsRoute exact path="/product/bigdata/depReport" component={DepReport} />
      <PropsRoute exact path="/product/bigdata/depReport/result" component={DepReportResult} />
      <PropsRoute exact path="/product/bigdata/cstRcScore" component={CstRcScore} />
      <PropsRoute exact path="/product/bigdata/cstRcScore/result" component={CstRcScoreResult} />
      <PropsRoute exact path="/product/bigdata/cstRcScore/dashboard" component={CstRcScoreDashboard} />

      <PropsRoute exact path="/back/purchased" component={Purchased} />
      <PropsRoute exact path="/back/order" component={Order} />
      <PropsRoute exact path="/back/invoice" component={Invoice} />
      <PropsRoute exact path="/back/setting" component={Setting} />

      <PropsRoute path="/" component={Home} />
    </Switch>
  );
}
Routing.propTypes = {};

export default memo(Routing);
